import * as Preact from "preact"
import "@frog/source/views/dev/DevEncounterEditorScreen.less"
import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import games from "@frog/source/data/games"

import Camera from "@frog/source/views/components/Camera.jsx"
import Cursor from "@frog/source/views/components/Cursor.jsx"
import EncounterArea from "@frog/source/views/components/EncounterArea.jsx"
import EditorModeSplash from "@frog/source/views/components/EditorModeSplash.jsx"

export default class DevEncounterEditorScreen {
    render() {
        if(App.game == undefined) {
            const game = games[Object.keys(games)[0]]
            return (
                <div class="DevEncounterDesignScreen">
                    <div class="Header">Encounters</div>
                    <span onClick={() => Navigation.go("/games/" + game.slug + "/chapters/" + (game.firstChapterKey || "1"))}>Please load a game</span>
                </div>
            )
        }

        return (
            <div class="DevEncounterDesignScreen"
                onMouseDown={(event) => Dev.devSelection.start()}
                onMouseUp={(event) => Dev.devSelection.finish()}
                onWheel={(event) => Dev.devSelection.wheel(event)}>
                <EditorModeSplash text="Geography Editor"/>
                <Camera chapter={App.game.chapter}>
                    <Cursor stage={Dev.loadedProtostage}/>
                    {Object.values(Dev.loadedProtostage.world.zones).map((encounter) => <Encounter encounter={encounter}/>)}
                    <WorldImage stage={Dev.loadedProtostage} screenspace="world"/>
                </Camera>
            </div>
        )
    }
}

class Encounter {
    constructor(props) {
        let vertices = props.encounter.points
        if(vertices == undefined) {
            const x1 = props.encounter.x
            const y1 = props.encounter.y
            const x2 = props.encounter.x + props.encounter.width
            const y2 = props.encounter.y + props.encounter.height
            vertices = [
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
            ]
            props.encounter.points = vertices
        }
    }
    render() {
        return (
            <div class="Encounter"
                isSelected={this.isSelected + ""}
                isHovered={this.isHovered + ""}>
                <EncounterArea class="Area" stage={Dev.loadedProtostage} encounter={this.props.encounter}/>
                {this.props.encounter.points.map((vertex, index) => <EncounterEdge pointA={vertex} pointB={this.props.encounter.points[(index + 1) % this.props.encounter.points.length]}/>)}
                {this.props.encounter.points.map((vertex) => <EncounterVertex point={vertex}/>)}
            </div>
        )
    }
    get isSelected() {
        return this.props.encounter.slug == Dev.devSelection.selectedEncounterKey
    }
    get isHovered() {
        return this.props.encounter.slug == Dev.devSelection.hoveredEncounterKey
            || this.props.encounter.slug == Dev.devSelection.listHoveredEncounterKey
    }
}

// TODO: this is redundant to stage.jsx
class WorldImage {
    render() {
        if(this.props.stage.images == undefined
        && this.props.stage.image != undefined) {
            this.props.stage.images = [this.props.stage.image]
        }
        if(this.props.stage.images == undefined) return
        return this.props.stage.images.map((image, index) => {
            if((image.screenspace ?? "world") != this.props.screenspace) return
            if(image.type == "polygon") {
                return <WorldImagePolygon stage={this.props.stage} image={image}/>
            }
            return (
                <div class="WorldImage" style={{
                    "background-image": "url(" + (image.url || image) + ")",
                    "width": (image.width ?? this.props.stage.world.width ?? 16) + "em",
                    "height": (image.height ?? this.props.stage.world.height ?? 9) + "em",
                    "top": (image.position?.y ?? image.y ?? 0) + "em",
                    "left": (image.position?.x ?? image.x ?? 0) + "em",
                    // "animationName": (App.game?.configuration?.squigglevision == "world" && index != 0 ? "squigglevision" : ""),
                    "z-index": image.position?.z ?? image.z ?? 0,
                    "mix-blend-mode": image.effect,
                    "transform": "rotate(" + (image.rotation ?? 0) + "deg)",
                    "margin-left": ((image.anchor?.x ?? 0) * image.width * -1) + "em",
                    "margin-top": ((image.anchor?.y ?? 0) * image.height * -1) + "em",
                    // "filter": image.isAnimated && `url("#squiggly-1")`
                    // "animationName": image.isAnimated && "rustling",
                    // "animationDelay": image.index * -1 + "s",
                    // "animationDuration": "10s",
                    "background-position-x": (image.anchor?.x || 0) * 100 + "%",
                    "background-position-y": (image.anchor?.y || 0) * 100 + "%",

                    "opacity": image.isFaded instanceof Function && image.isFaded(this.props.stage) == true ? 0.75 : 1,
                    "display": image.isHidden instanceof Function && image.isHidden(this.props.stage) == true ? "none" : "block",
                }}/>
            )
        })
    }
}

const VERTEX_SIZE = 0.4
class EncounterVertex {
    render() {
        return (
            <div class="Vertex" isSelected={this.isSelected} style={{
                "width": VERTEX_SIZE + "em",
                "height": VERTEX_SIZE + "em",
                "left": this.props.point.x - VERTEX_SIZE/2 + "em",
                "top": this.props.point.y - VERTEX_SIZE/2 + "em",
                "clip-path": "circle(50%)",
            }}/>
        )
    }
    get isSelected() {
        return this.props.point.key == Dev.devSelection.selectedVertexKey
            || Dev.devSelection.multiselectedVertexKeys.includes(this.props.point.key)
    }
}
const EDGE_THICKNESS = 0.1
class EncounterEdge {
    render() {
        const width = this.props.pointB.x - this.props.pointA.x
        const height = this.props.pointB.y - this.props.pointA.y
        const style = {
            "left": this.props.pointA.x + "em",
            "top": this.props.pointA.y + "em",
            "width": Math.sqrt(width * width + height * height) + "em",
            "height": EDGE_THICKNESS + "em",
            "transform-origin": "left",
            "transform": "rotate(" + Math.atan2(height, width) + "rad)",
        }
        return <div class="Edge" isSelected={this.isSelected} style={style}/>
    }
    get isSelected() {
        return Dev.devSelection.multiselectedVertexKeys.includes(this.props.pointA.key)
            && Dev.devSelection.multiselectedVertexKeys.includes(this.props.pointB.key)
    }
}
